import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Spin } from "antd";
import ModalComponent from "../../../components/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";
import {
  CreateFileApi,
  GetServiceTypeListApi,
} from "../../../api/request/service";

const CreateFileModal = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const [service, setService] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isCreateLoading, setIsCreateLoading] = useState(false);

  const getServiceList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetServiceTypeListApi();
      if (data?.status) {
        setService(data?.data);
        if (data?.data?.length) setSelectedService(data?.data[0]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getServiceList();
  }, []);

  const createFileHandler = async () => {
    try {
      setIsCreateLoading(true);
      const params = {
        service_type_id: selectedService?.id,
      };
      const { data } = await CreateFileApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setIsOpen(false);
        navigate(`/file/${data?.data?.id}`);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsCreateLoading(false);
    }
  };

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} title="Available Services">
      {isLoading ? (
        <div className="flex flex-col items-center gap-2 mt-16">
          <Spin />
          <p className="text-secondaryLight1">Loading...</p>
        </div>
      ) : (
        <div>
          <div className="grid grid-cols-2 gap-5">
            {service?.map((item, index) => (
              <div
                key={`service_${index}`}
                className={`p-3 text-center flex items-center justify-center font-medium border rounded-md cursor-pointer duration-500 ${
                  selectedService?.id === item?.id
                    ? "text-primary border-primary bg-primaryLight"
                    : "text-secondaryLight1"
                }`}
                onClick={() => setSelectedService(item)}
              >
                {item?.name}
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <LoadableButton
              isLoading={isCreateLoading}
              onClick={createFileHandler}
              lable="Create"
              loadingLable="Creating file..."
              disabled={!selectedService}
            />
          </div>
        </div>
      )}
    </ModalComponent>
  );
};

export default CreateFileModal;
